export const environment = {
  production: false,
  url: 'https://api-orion-dev.otecsys.org/',
  fileHostingApiUrl: 'https://2o.mom', // 'https://dev-obin-api.zp.wtf',
  urlRedirectionApiUrl:  'https://z2.mom/', // 'https://dev-urlredirection-api.zp.wtf/'
  urlShortenerUrl: 'https://1m.mom/'
};
